export const writeUnsatisfiableExpressionError = (expression) => `${expression} results in an unsatisfiable type`;
export const writePrefixedPrivateReferenceMessage = (def) => `Private type references should not include '#'. Use '${def.slice(1)}' instead.`;
